/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectionStrategy, Component, DestroyRef, Input, OnInit, inject} from '@angular/core';
import template from './api-key-list-page.component.html';

import {SignalAdminListColumn, SignalAdminResourceListStateFactory} from '../../common/controller/signal-admin-resource-list-state';
import {ApiKeyApiService, ApiKeyModel} from './api-key-api.service';
import {UIRouterModule} from '@uirouter/angular';
import {APP_SHARED} from '../../common/app-shared';
import {SignalAdminResourceListComponent} from '../../common/controller/signal-admin-resource-list.component';

@Component({
  standalone: true,
  imports: [...APP_SHARED, UIRouterModule, SignalAdminResourceListComponent],
  selector: 'adn-api-key-list-page',
  template,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApiKeyListPageComponent implements OnInit {
  readonly itemStateName = 'app.adm.api-keys.api-key';

  readonly columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {label: 'scopes', param: '', sortable: false},
    {label: 'expiry', param: '', sortable: false},
    {label: 'lastUsed', param: '', sortable: false}
  ];

  readonly list = inject(SignalAdminResourceListStateFactory).create<ApiKeyModel>(
    inject(ApiKeyApiService),
    {listId: 'fullApiKeyList'},
    inject(DestroyRef)
  );

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  ngOnInit(): void {
    this.list.load();
  }
}
